import { CurrencyItem, GraphQlBody, ParsedStats, StatsRange, StatsResponse } from '../models/order/order-statistics.model';

export function extractCurrency(range: StatsRange): CurrencyItem {
  const empty: CurrencyItem = { currencyCode: 'BRL', quantity: 0, value: 0 };

  if (!range?.bodyJson) return empty;

  let body: GraphQlBody;
  try {
    body = JSON.parse(range.bodyJson) as GraphQlBody;
  } catch (e) {
    console.error('Falha ao parsear bodyJson:', range.bodyJson, e);
    return empty;
  }

  const cur = body?.data?.ordersExtendSearch?.currencies?.[0];
  if (!cur) return empty;

  return {
    currencyCode: cur.currencyCode ?? 'BRL',
    quantity: Number(cur.quantity ?? 0),
    value: Number(cur.value ?? 0),
  };
}

export function parseStatistics(data: StatsResponse): ParsedStats {
  return {
    today: extractCurrency(data.today),
    yesterdaySameHour: extractCurrency(data.yesterdaySameHour),
    lastWeekFullDay: extractCurrency(data.lastWeekFullDay),
  };
}
